/**
 * Stage name constants
 */
export enum STAGE {
  DEV = 'DEV',
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  GAMMA = 'GAMMA',
  ONEBOX = 'ONEBOX',
  PROD = 'PROD',
}

/**
 * Domain to stage map
 */
export const DOMAIN_TO_STAGE: Record<string, STAGE> = {
  'eagles.team.hrsc.pxt.amazon.dev': STAGE.DEV,
  'alpha.hrsc.pxt.amazon.dev': STAGE.ALPHA,
  'beta.hrsc.pxt.amazon.dev': STAGE.BETA,
  'gamma.hrsc.pxt.amazon.dev': STAGE.GAMMA,
  'onebox.hrsc.pxt.amazon.dev': STAGE.ONEBOX,
  'hrsc.pxt.amazon.dev': STAGE.PROD,
  // Service Central alias domains. Served from the same distribution as the hrsc
  // domains, so they map to the same stages. Without these, getCurrentStage()
  // returns undefined on sc.pxt.amazon.dev and stage-config lookups crash.
  'alpha.sc.pxt.amazon.dev': STAGE.ALPHA,
  'beta.sc.pxt.amazon.dev': STAGE.BETA,
  'gamma.sc.pxt.amazon.dev': STAGE.GAMMA,
  'onebox.sc.pxt.amazon.dev': STAGE.ONEBOX,
  'sc.pxt.amazon.dev': STAGE.PROD,
};

/**
 * Stage to domain map
 */
export const STAGE_TO_DOMAIN: Record<STAGE, string> = {
  [STAGE.DEV]: 'eagles.team.hrsc.pxt.amazon.dev',
  [STAGE.ALPHA]: 'alpha.hrsc.pxt.amazon.dev',
  [STAGE.BETA]: 'beta.hrsc.pxt.amazon.dev',
  [STAGE.GAMMA]: 'gamma.hrsc.pxt.amazon.dev',
  [STAGE.ONEBOX]: 'onebox.hrsc.pxt.amazon.dev',
  [STAGE.PROD]: 'hrsc.pxt.amazon.dev',
};
